import { render, staticRenderFns } from "./webhook.vue?vue&type=template&id=5b2d5658&scoped=true&"
import script from "./webhook.vue?vue&type=script&lang=js&"
export * from "./webhook.vue?vue&type=script&lang=js&"
import style0 from "./webhook.vue?vue&type=style&index=0&id=5b2d5658&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2d5658",
  null
  
)

export default component.exports